export default {
	logo: {
		url: "https://egzaminlek.pl/static/images/Icon-40.png",
		alt: "egzaminlek-logo",
	},
	facebook: {
		url: "https://www.facebook.com/egzaminlek",
		appId: "655609961298134",
	},
	urls: {
		pricing: "https://egzaminlek.pl/kup-dostep/",
		pricingPes: "https://egzaminlek.pl/kup-dostep-pes/",
		landing: "https://egzaminlek.pl",
		panel: "https://panel.egzaminlek.pl",
	},
	staticUrls: {
		images: {
			notFound: "https://egzaminlek.pl/static/panel/404.png",
		},
		gifs: {
			loader: "https://egzaminlek.pl/static/panel/loader.gif",
		},
	},
	dictionary: {
		serviceName: "EgzaminLEK",
		examName: "LEK",
		description: "Lekarski Egzamin Końcowy",
	},
	title: "EgzaminLEK - panel",
	serviceId: "egzaminlek.pl",
	sentryDsn:
		"https://36a045f089b2419db53171eae9be97e2@o461032.ingest.sentry.io/5462256",
	flashcardsLimits: {
		decks: 100,
		flashcards: 200,
	},
};
